/* istanbul ignore file */
import axios from '../requester';
import { API } from '../constants/api-urls';
import _ from 'lodash';
import moment from 'moment';

export const JOB_NAMES = {
  TEAM_SYNC_CONTRIBUTORS: 'TeamSyncContributors',
  ONBOARDING: 'Onboarding',
  REPOSITORY_BACKFILL: 'RepositoryBackfill',
  PmImportStrategyAutoSelection: 'PmImportStrategyAutoSelection',
  REPOSITORIES_COLLECTOR: 'RepositoriesCollector',
  SYNC_GIT_TEAMS: 'SyncGitTeams'
};

export const JOB_STATES = {
  initiated: 'initiated',
  started: 'started',
  completed: 'completed',
  failed: 'failed',
  not_completed: 'not_completed'
};

const FINAL_JOB_STATES = [
  JOB_STATES.completed,
  JOB_STATES.failed,
  JOB_STATES.not_completed
];

export const getJob = async jobName =>
  await axios.get(API.JOBS_SUITES_PATH, {
    params: {
      jobs_suite_name: jobName
    }
  });

export const jobPollingListener = async ({
  jobName,
  timeout = 3,
  limitRequests = 10,
  triggeredBefore = [30, 'seconds'],
  onStateChange = (state, jobDetails) => {}
}) => {
  if (!_.values(JOB_NAMES).includes(jobName)) {
    throw new Error(`jobName: ${jobName} not exists`);
  }
  const getLatestJob = jobs =>
    _.get(_.orderBy(jobs, 'triggered_at', 'desc'), '[0]');
  const getJobById = (jobs, jobId) =>
    _.find(jobs, job => job.jobs_suite_uuid === jobId);
  const isJobTriggeredBefore = job =>
    moment(job.triggered_at) > moment().subtract(...triggeredBefore);

  let requestCounter = 0;
  let jobId;
  let jobState;
  // const mockJob = MockJob(JOB_NAMES.SYNC_GIT_TEAMS);

  const jobListener = async () => {
    const pollingAgain = () =>
      requestCounter < limitRequests && setTimeout(jobListener, timeout * 1000);

    try {
      requestCounter++;
      const jobsRes = await getJob(jobName);
      // const jobsRes = await mockJob.fetchJob();
      const jobs = _.get(jobsRes, 'jobs', []);

      if (jobs.length === 0) {
        // no jobs exists yet
        return pollingAgain();
      }

      const latestJob = getLatestJob(jobs);
      let job;

      if (!jobId) {
        if (!isJobTriggeredBefore(latestJob)) {
          return pollingAgain();
        }

        job = latestJob;
        jobId = _.get(latestJob, 'jobs_suite_uuid');
      } else {
        job = getJobById(jobs, jobId);
      }

      const currJobState = _.get(job, 'state');

      if (currJobState !== jobState) {
        // jobState has changed
        jobState = currJobState;
        onStateChange(currJobState, job);
      }
      if (!FINAL_JOB_STATES.includes(currJobState)) {
        pollingAgain();
      }
    } catch (e) {
      pollingAgain();
    }
  };
  jobListener();
};
